// ----------------------------------------------------------------------

export function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";
const ROOTS_CONFIGURATION = "/configuration";
const ROOTS_CATALOG = "/catalog";
const ROOTS_PAYMENTS = "/payments";
const ROOTS_EXPENSE = "/expense";
const ROOTS_USERONBOARD = "/reg";
const ROOTS_REPORT = "/report";
const ROOT_TRAINING = "/training";
const ROOTS_DIMENSION = "/dimension";
const ROOTS_TASKS = "/tasks";
// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
  register: path(ROOTS_AUTH, "/register"),
  loginUnprotected: path(ROOTS_AUTH, "/login-unprotected"),
  registerUnprotected: path(ROOTS_AUTH, "/register-unprotected"),
  verify: path(ROOTS_AUTH, "/verify"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
  newPassword: path(ROOTS_AUTH, "/new-password"),
  preRegister: path(ROOTS_AUTH, "/pre-register"),
  preVerify: path(ROOTS_AUTH, "/pre-verify"),
  newRegister: path(ROOTS_AUTH, "/new-register"),
  impersonate: path(ROOTS_AUTH, "/impersonate"),
  twoFA: path(ROOTS_AUTH, "/2fa"),
};

export const PATH_USERONBOARD = {
  root: ROOTS_USERONBOARD,
  useronboard: path(ROOTS_USERONBOARD, "/useronboard"),
};

export const PATH_PAGE = {
  comingSoon: "/coming-soon",
  maintenance: "/maintenance",
  pricing: "/pricing",
  payment: "/payment",
  about: "/about-us",
  contact: "/contact-us",
  faqs: "/faqs",
  page403: "/403",
  page404: "/404",
  page500: "/500",
  components: "/components",
  verification: "/verification",
};

export const PATH_CONFIGURATION = {
  root: ROOTS_CONFIGURATION,
  general: {
    documentConfiguration: path(ROOTS_CONFIGURATION, "/document-configuration"),
    discrepancyConfiguration: path(
      ROOTS_CONFIGURATION,
      "/discrepancy-configuration",
    ),
    inputCSVMapping: path(ROOTS_CONFIGURATION, "/input-csv-mapping"),
    outputCSVMapping: path(ROOTS_CONFIGURATION, "/output-csv-mapping"),
    expectedValuesConfiguration: path(
      ROOTS_CONFIGURATION,
      "/predefined-values-configuration",
    ),
    erpSyncConfiguration: path(ROOTS_CONFIGURATION, "/erp-sync-configuration"),
    workflowConfiguration: path(ROOTS_CONFIGURATION, "/workflow"),
    codingTemplatesConfiguration: path(
      ROOTS_CONFIGURATION,
      "/coding-templates",
    ),
    postingDatePolicyConfiguration: path(
      ROOTS_CONFIGURATION,
      "/posting-date-policy",
    ),
    peppolPartyRegistrationConfiguration: path(
      ROOTS_CONFIGURATION,
      "/peppol-party-registration",
    ),
    extractionConfiguration: path(
      ROOTS_CONFIGURATION,
      "/extraction-configuration",
    ),
    validationConfiguration: path(
      ROOTS_CONFIGURATION,
      "/validation-configuration",
    ),
  },
};

export const PATH_PAYMENTS = {
  root: ROOTS_PAYMENTS,
  general: {
    bankAccounts: path(ROOTS_PAYMENTS, "/bank-accounts"),
    invoicePayments: path(ROOTS_PAYMENTS, "/invoice-payments"),
    invoiceTransactions: path(ROOTS_PAYMENTS, "/bank-transactions"),
    paymentSchedules: path(ROOTS_PAYMENTS, "/payment-schedule"),
    bankReconciliation: path(ROOTS_PAYMENTS, "/bank-reconciliation"),
    bankReconciliationV2: path(ROOTS_PAYMENTS, "/bank-reconciliationV2"),
  },
};
export const PATH_EXPENSE = {
  root: ROOTS_EXPENSE,
  general: {
    employees: path(ROOTS_EXPENSE, "/employees"),
    expenses: path(ROOTS_EXPENSE, "/expenses"),
  },
};

export const PATH_CATALOG = {
  root: ROOTS_CATALOG,
  general: {
    items: path(ROOTS_CATALOG, "/items"),
    taxes: path(ROOTS_CATALOG, "/taxes"),
    currencies: path(ROOTS_CATALOG, "/currencies"),
    paymentMethods: path(ROOTS_CATALOG, "/payment-methods"),
    paymentTerms: path(ROOTS_CATALOG, "/payment-terms"),
  },
};
export const PATH_REPORT = {
  root: ROOTS_REPORT,
  general: {
    workflow: path(ROOTS_REPORT, "/workflow"),
    documentUsage: path(ROOTS_REPORT, "/document-usage"),
    selfTraining: path(ROOTS_REPORT, "/selftraining"),
    yearWiseDocSummary: path(ROOTS_REPORT, "/yearwise-document-summary"),
    customReports: (reportId: string) =>
      path(ROOTS_REPORT, `/custom-reports/${reportId}`),
    customerPayment: path(ROOTS_REPORT, "/customer-payment"),
    discrepancy: path(ROOTS_REPORT, "/discrepancy"),
  },
};

export const PATH_TRAINING = {
  root: ROOT_TRAINING,
  general: {
    selfTraining: path(ROOT_TRAINING, "/self-training"),
    extractionRules: path(ROOT_TRAINING, "/extraction-rules"),
  },
};

export const PATH_DIMENSION = {
  root: ROOTS_DIMENSION,
  dimensionValues: (id: string) =>
    path(ROOTS_DIMENSION, `/${id}/dimension-values`),
};

export const PATH_TASKS = {
  root: ROOTS_TASKS,
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, "/app"),
    ecommerce: path(ROOTS_DASHBOARD, "/ecommerce"),
    analytics: path(ROOTS_DASHBOARD, "/analytics"),
    analyticsV2: path(ROOTS_DASHBOARD, "/analyticsV2"),
    analyticsV3: path(ROOTS_DASHBOARD, "/analytics"),
    banking: path(ROOTS_DASHBOARD, "/banking"),
    booking: path(ROOTS_DASHBOARD, "/booking"),

    payable: {
      root: path(ROOTS_DASHBOARD, "/payable"),
      general: {
        purchaseInvoice: path(ROOTS_DASHBOARD, "/payable/purchase-invoice"),
        purchaseOrder: path(ROOTS_DASHBOARD, "/payable/purchase-order"),
        purchaseDeliveryNote: path(
          ROOTS_DASHBOARD,
          "/payable/purchase-delivery-note",
        ),
      },
    },
    documents: {
      root: path(ROOTS_DASHBOARD, "/documents"),
      general: {
        review: path(ROOTS_DASHBOARD, "/documents/review"),
        mailInbox: path(ROOTS_DASHBOARD, "/documents/mailinbox"),
        createDocument: path(ROOTS_DASHBOARD, "/documents/createdocument"),
        createPurchaseOrder: path(
          ROOTS_DASHBOARD,
          "/documents/create-purchase-order",
        ),
        createSaleDeliveryNote: path(
          ROOTS_DASHBOARD,
          "/documents/create-sale-delivery-note",
        ),
        verifactu: {
          createRegularInvoice: path(
            ROOTS_DASHBOARD,
            "/documents/verifactu/create-regular-invoice",
          ),
          createSimplifiedInvoice: path(
            ROOTS_DASHBOARD,
            "/documents/verifactu/create-simplified-invoice",
          ),
          createCreditNote: path(
            ROOTS_DASHBOARD,
            "/documents/verifactu/create-credit-note",
          ),
          createDebitNote: path(
            ROOTS_DASHBOARD,
            "/documents/verifactu/create-debit-note",
          ),
          createCorrectiveInvoice: path(
            ROOTS_DASHBOARD,
            "/documents/verifactu/create-corrective-invoice",
          ),
        },
        SDI: {
          createRegularInvoice: path(
            ROOTS_DASHBOARD,
            "/documents/sdi/create-regular-invoice",
          ),
          createCreditNote: path(
            ROOTS_DASHBOARD,
            "/documents/sdi/create-credit-note",
          ),
        },
        sii: {
          createRegularInvoice: path(
            ROOTS_DASHBOARD,
            "/documents/sii/create-regular-invoice",
          ),
          createSimplifiedInvoice: path(
            ROOTS_DASHBOARD,
            "/documents/sii/create-simplified-invoice",
          ),
          createCreditNote: path(
            ROOTS_DASHBOARD,
            "/documents/sii/create-credit-note",
          ),
          createCorrectiveInvoice: path(
            ROOTS_DASHBOARD,
            "/documents/sii/create-corrective-invoice",
          ),
          createReplacementForm: path(
            ROOTS_DASHBOARD,
            "/documents/sii/create-replacement-form",
          ),
        },
        france: {
          createRegularInvoice: path(
            ROOTS_DASHBOARD,
            "/documents/france/create-regular-invoice",
          ),
        },
        createPayment: path(ROOTS_DASHBOARD, "/documents/createpayment"),
      },
    },
    discrepancy: path(ROOTS_DASHBOARD, "/view-discrepancy"),
    newIntegeration: path(ROOTS_DASHBOARD, "/newintegration"),
    integration: path(ROOTS_DASHBOARD, "/integration"),
    configuration: path(ROOTS_DASHBOARD, "/configuration"),
    users: path(ROOTS_DASHBOARD, "/users"),
    companies: path(ROOTS_DASHBOARD, "/companies"),
    comingSoon: path(ROOTS_DASHBOARD, "/comingSoon"),
    workflow: path(ROOTS_DASHBOARD, "/workflow"),
    workflowTemplates: path(ROOTS_DASHBOARD, "/workflow-templates"),
    approval: path(ROOTS_DASHBOARD, "/approved-documents"),
    dataAnalytics: path(ROOTS_DASHBOARD, "/dataAnalytics"),
    resourceSaved: path(ROOTS_DASHBOARD, "/resourceSaved"),
    upgrade: path(ROOTS_DASHBOARD, "/upgrade"),
    feedback: path(ROOTS_DASHBOARD, "/feedback"),
    adminUpdateModels: path(ROOTS_DASHBOARD, "/adminUpdateModels"),
    checkout: path(ROOTS_DASHBOARD, "/checkout"),
    stripe: path(ROOTS_DASHBOARD, "/stripe"),
    newStripe: path(ROOTS_DASHBOARD, "/newStripe"),
    agentReview: path(ROOTS_DASHBOARD, "/agentreview"),
    adminUpgradePlan: path(ROOTS_DASHBOARD, "/adminUpgradePlan"),
    adminReport: path(ROOTS_DASHBOARD, "/adminReport"),
    release: path(ROOTS_DASHBOARD, "/release"),
    suppliers: path(ROOTS_DASHBOARD, "/suppliers"),
    legalDocuments: path(ROOTS_DASHBOARD, "/suppliers/legal-documents"),
    onboardingTemplate: path(ROOTS_DASHBOARD, "/suppliers/customise-onboarding"),
    customers: path(ROOTS_DASHBOARD, "/customers"),
    // payments: path(ROOTS_DASHBOARD, "/payments"),
    expense: {
      root: ROOTS_EXPENSE,
      general: {
        employees: path(ROOTS_DASHBOARD, "/employees"),
      },
    },
    payments: {
      root: ROOTS_PAYMENTS,
      general: {
        payments: path(ROOTS_DASHBOARD, "/payments"),
        transactions: path(ROOTS_DASHBOARD, "/payments/transactions"),
      },
    },
    catalog: {
      root: ROOTS_CATALOG,
      general: {
        items: path(ROOTS_DASHBOARD, "/catalog/items"),
        taxes: path(ROOTS_DASHBOARD, "/catalog/taxes"),
      },
    },
  },
  mail: {
    root: path(ROOTS_DASHBOARD, "/mail"),
    all: path(ROOTS_DASHBOARD, "/mail/all"),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, "/chat"),
    new: path(ROOTS_DASHBOARD, "/chat/new"),
    view: (name: string) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, "/calendar"),
  kanban: path(ROOTS_DASHBOARD, "/kanban"),
  permissionDenied: path(ROOTS_DASHBOARD, "/permission-denied"),
  user: {
    root: path(ROOTS_DASHBOARD, "/user"),
    new: path(ROOTS_DASHBOARD, "/user/new"),
    list: path(ROOTS_DASHBOARD, "/user/list"),
    cards: path(ROOTS_DASHBOARD, "/user/cards"),
    profile: path(ROOTS_DASHBOARD, "/user/profile"),
    account: path(ROOTS_DASHBOARD, "/user/account"),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, "/e-commerce"),
    shop: path(ROOTS_DASHBOARD, "/e-commerce/shop"),
    list: path(ROOTS_DASHBOARD, "/e-commerce/list"),
    checkout: path(ROOTS_DASHBOARD, "/e-commerce/checkout"),
    new: path(ROOTS_DASHBOARD, "/e-commerce/product/new"),
    view: (name: string) =>
      path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name: string) =>
      path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(
      ROOTS_DASHBOARD,
      "/e-commerce/product/nike-blazer-low-77-vintage/edit",
    ),
    demoView: path(
      ROOTS_DASHBOARD,
      "/e-commerce/product/nike-air-force-1-ndestrukt",
    ),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, "/invoice"),
    list: path(ROOTS_DASHBOARD, "/invoice/list"),
    new: path(ROOTS_DASHBOARD, "/invoice/new"),
    view: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(
      ROOTS_DASHBOARD,
      "/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit",
    ),
    demoView: path(
      ROOTS_DASHBOARD,
      "/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
    ),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, "/blog"),
    posts: path(ROOTS_DASHBOARD, "/blog/posts"),
    new: path(ROOTS_DASHBOARD, "/blog/new"),
    view: (title: string) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(
      ROOTS_DASHBOARD,
      "/blog/post/apply-these-7-secret-techniques-to-improve-event",
    ),
  },
};

export const PATH_DOCS = "https://docs-minimals.vercel.app/introduction";

export { PATH_PAYABLES } from "./nestedPaths/payablesPath";
export { PATH_PROCUREMENT } from "./nestedPaths/procurementPath";
export { PATH_RECEIVABLES } from "./nestedPaths/receivablesPath";
